<div class="container-fluid">
  <app-header titleText="Admin">
  </app-header>
  <div class="card bg-light">
    <div class="card-header">
      <h3>IDI Dealers</h3>
      <div class="col">
        <span>Dealers are business entities in which IDI conducts business with.  Dealers are often subscribers for idi-bidit.com.</span>
        <span class="float-right"><button (click)="exportDealers()" [disabled]="isRequesting ? 'disabled' : ''" class="btn btn-bidit-action btn-sm">Export Dealers</button></span>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>

    </div>
    <div class="card-body">
        <div class="form-inline float-right mb-2">
            <input id="searchText" name="searchText" placeholder="Search" class="form-control mr-2" [(ngModel)]="searchText">
            <button class="btn btn-bidit-action btn-sm mr-2" (click)="searchDealers()" type="submit">Apply Filter</button>
            <div class="float-right">
                <button (click)="showEdit(null)" class="btn btn-bidit-navigate btn-sm">Add</button>
            </div>
        </div>

        <div class="clearfix"></div>
        <mat-table class="table table-bidit table-hover" style="width:100%" [dataSource]="dataSource"
                   matSort matSortActive="projectName" matSortDirection="asc">
            <ng-container matColumnDef="dealer_BusinessName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Business</mat-header-cell>
                <mat-cell *matCellDef="let dealer">
                    {{dealer.dealer_BusinessName}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dealer_City">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>City</mat-header-cell>
                <mat-cell *matCellDef="let dealer">
                    {{dealer.dealer_City}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dealer_State">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>State</mat-header-cell>
                <mat-cell *matCellDef="let dealer">
                    {{dealer.dealer_State}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dealer_OfficePhone">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Office Phone</mat-header-cell>
                <mat-cell *matCellDef="let dealer">
                    {{dealer.dealer_OfficePhone}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dealer_Email">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Email</mat-header-cell>
                <mat-cell *matCellDef="let dealer">
                    {{dealer.dealer_Email}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dealer_LastName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Contact</mat-header-cell>
                <mat-cell *matCellDef="let dealer">
                    {{dealer.dealer_LastName}}, {{dealer.dealer_FirstName}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef class="bidit-header" i18n></mat-header-cell>
                <mat-cell *matCellDef="let dealer">
                    <div class="form-inline">
                        <label id="dealer_status_active{{dealer.dealer_ID}}" [ngClass]="{'text-success' : dealer.dealer_IsActive}">active</label>
                        <input (change)="toggleStatus(dealer.dealer_ID)" type="checkbox" name="dealer_status_{{dealer.dealer_ID}}" id="dealer_status_{{dealer.dealer_ID}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!dealer.dealer_IsActive" (ngModelChange)="dealer.dealer_IsActive = $event">
                        <label id="dealer_status_inactive{{dealer.dealer_ID}}" [ngClass]="{'text-danger' : !dealer.dealer_IsActive}">inactive</label>
                        <a class="btn-bidit-edit-dark ml-4 mr-2" (click)="showEdit(dealer.dealer_ID)"></a>
                        <button (click)="showUsers(dealer.dealer_ID)" class="btn btn-bidit-navigate">View Users</button>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>

        <mat-paginator [length]="dealers?.length" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
    </div>
  </div>
</div>
